module.exports = __webpack_public_path__ + "static/media/soft-drink.3959f837.png";